<app-ion-common-header
  [id]="headerId"
  [labelBtnBack]="labelBtnBack"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div class="content-faq" *ngIf="content?.length > 0">
    <h1>Perguntas frequentes</h1>
    <ids-accordion-group class="ids-theme-change">
      <ids-accordion *ngFor="let item of content" header="{{ item.pergunta }}">
        <p [innerHTML]="item.resposta" class="ids-body-text"></p>
      </ids-accordion>
    </ids-accordion-group>
    <p class="footer-info">{{ contentFooter }}</p>
  </div>
</ion-content>
